<!-- src/App.vue -->
<template>
  <div id="app">
    <router-view />
    <van-tabbar v-model="active" @change="onTabChange">
      <van-tabbar-item icon="user-o" name="user">个人中心</van-tabbar-item>
      <van-tabbar-item icon="service-o" name="service">在线客服</van-tabbar-item>
      <van-tabbar-item icon="gold-coin-o" name="recharge">账户充值</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      active: 'user'
    }
  },
  mounted() {
    // 根据当前路由设置选中的 tab
    const routeMap = {
      '/user': 'user',
      '/customer-service': 'service',
      '/recharge': 'recharge'
    }
    this.active = routeMap[this.$route.path] || 'user'
  },
  methods: {
    onTabChange(name) {
      const routeMap = {
        user: '/user',
        service: '/customer-service',
        recharge: '/recharge'
      }
      this.$router.push(routeMap[name])
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background-color: #f5f5f5;
}

#app {
  min-height: 100vh;
  padding-bottom: 50px; // 为底部 tabbar 留出空间
}
</style>